<aside class="sidebar-shell" aria-label="Primary navigation">
  <div class="sidebar-brand">
    <img src="assets/images/PBlogo.png" alt="Fidelity Insurance logo" />
    <div class="sidebar-brand-text">
      <div class="sidebar-brand-subtitle">Supplier Portal</div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <mat-nav-list>
      <ng-container *ngFor="let sidebarItem of sidebarItems">
        <div class="sidebar-group" *ngIf="!sidebarItem.groupTitle">
          <a
            *ngIf="!sidebarItem.submenu.length"
            mat-list-item
            class="sidebar-link"
            [routerLink]="sidebarItem.path"
            routerLinkActive="active-link"
            (click)="onLeafClick()"
          >
            <span class="sidebar-link-content">
              <mat-icon>{{ sidebarItem.icon || "chevron_right" }}</mat-icon>
              <span class="sidebar-link-text">{{ sidebarItem.title | translate }}</span>
            </span>
          </a>

          <button
            *ngIf="sidebarItem.submenu.length"
            mat-list-item
            type="button"
            class="sidebar-group-toggle"
            (click)="toggleGroup(sidebarItem)"
            [attr.aria-expanded]="isExpanded(sidebarItem)"
          >
            <span class="sidebar-group-toggle-content">
              <mat-icon>{{ sidebarItem.icon || "folder" }}</mat-icon>
              <span class="sidebar-group-toggle-text">{{ sidebarItem.title | translate }}</span>
              <mat-icon>{{ isExpanded(sidebarItem) ? "expand_less" : "expand_more" }}</mat-icon>
            </span>
          </button>

          <div class="sidebar-submenu" *ngIf="sidebarItem.submenu.length && isExpanded(sidebarItem)">
            <a
              *ngFor="let sidebarSubItem of sidebarItem.submenu"
              mat-list-item
              class="sidebar-sublink"
              [routerLink]="sidebarSubItem.path"
              routerLinkActive="active-link"
              (click)="onLeafClick()"
            >
              <span class="sidebar-sublink-content">
                <mat-icon>{{ sidebarSubItem.icon || "chevron_right" }}</mat-icon>
                <span class="sidebar-sublink-text">{{ sidebarSubItem.title | translate }}</span>
              </span>
            </a>
          </div>
        </div>
      </ng-container>
    </mat-nav-list>
  </nav>

  <div class="sidebar-footer">
    <button mat-stroked-button color="warn" type="button" class="sidebar-logout" (click)="logout()">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </div>
</aside>
